import { TenantNavigationComponent } from './tenant-navigation/tenant-navigation.component';
import { NgModule } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';

import { HeaderNavComponent } from './header-nav/header-nav.component';
import { DefaultComponent } from '../pages/default/default.component';
import { AsideNavComponent } from './aside-nav/aside-nav.component';
import { FooterComponent } from './footer/footer.component';
import { QuickSidebarComponent } from './quick-sidebar/quick-sidebar.component';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { TooltipsComponent } from './tooltips/tooltips.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HrefPreventDefaultDirective } from '../../_directives/href-prevent-default.directive';
import { UnwrapTagDirective } from '../../_directives/unwrap-tag.directive';
import { BoxAnalysisComponent } from './box-analysis/box-analysis.component';

import { RightAsideNavComponent } from './right-aside-nav/right-aside-nav.component';
import { RightAsideNav2Component } from './right-aside-nav-2/right-aside-nav-2.component';
import { RightAsideNavNestedComponent } from './right-aside-nav-nested/right-aside-nav-nested.component';
import { InfoAnalysisComponent } from './info-analysis/info-analysis.component';
import { RightFilterMenuComponent } from './right-filter-menu/right-filter-menu.component'

import { AppVersionComponent } from './app-version/app-version.component';
import { SwitchComponent } from './switch/switch.component';
import { HtmlEditorComponent } from './html-editor/html-editor.component';
import { TenantAssetComponent } from './tenant-asset/tenant-asset.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QrCodeComponent } from './qrcode/qrcode.component';

@NgModule({
    declarations: [
        TenantNavigationComponent,
        LayoutComponent,

        HeaderNavComponent,
        DefaultComponent,
        AsideNavComponent,
        FooterComponent,
        QuickSidebarComponent,
        ScrollTopComponent,
        TooltipsComponent,
        HrefPreventDefaultDirective,
        UnwrapTagDirective,
        BoxAnalysisComponent,
        RightAsideNavComponent,
        RightAsideNav2Component,
        RightAsideNavNestedComponent,
        InfoAnalysisComponent,
        RightFilterMenuComponent,
        AppVersionComponent,
        SwitchComponent,
        HtmlEditorComponent,
        TenantAssetComponent,
        QrCodeComponent
    ],
    exports: [
        TenantNavigationComponent,
        LayoutComponent,

        HeaderNavComponent,
        DefaultComponent,
        AsideNavComponent,
        FooterComponent,
        QuickSidebarComponent,
        ScrollTopComponent,
        TooltipsComponent,
        HrefPreventDefaultDirective,
        BoxAnalysisComponent,
        RightAsideNavComponent,
        RightAsideNav2Component,
        RightAsideNavNestedComponent,
        InfoAnalysisComponent,
        RightFilterMenuComponent,
        AppVersionComponent,
        SwitchComponent,
        HtmlEditorComponent,
        TenantAssetComponent,
        QrCodeComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
    ]
})
export class LayoutModule {
}